import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SnackbarComponent } from './snackbar.component';

@NgModule({
    imports: [CommonModule],
    exports: [SnackbarComponent],
    declarations: [SnackbarComponent],
    providers: [],
})
export class SnackbarModule { }
